import { Fragment, useState } from 'react';
import {useSelector} from 'react-redux';
import { PowerBIEmbed } from 'powerbi-client-react';
import powerbi, { Embed, Report, Page } from 'powerbi-client';
import { ISlicerState, ISlicer, IVisual } from 'powerbi-models'

import '../../styles/report.css';
import {powerbiTypes} from '../../constanst';
import { RootState} from '../../store/store';

import {usePowerbiInfo} from '../../hooks/usePowerbiInfo';
import ExceptionPage from "../../pages/ExceptionPage";
import { isEmptyObject } from 'jquery';
import NavigationList from './NavigationList';
import { isMobile } from 'react-device-detect';
import reportWebVitals from '../../reportWebVitals';
import { Button, Affix, Dropdown, Menu } from "antd";
import { Filter } from '../../types/resourceType';
import ExportButton from './ExportButton';


const PowerBIEmbedComponent = ()=>{
  const reportState = useSelector((state:RootState) => state.report);
  const menuState = useSelector((state:RootState) => state.menu);
  const powerbiInfo = usePowerbiInfo();
  const [report, setReport] = useState<Report | undefined>(undefined);
  const [showMenu, setShowMenu] = useState(false);

  const getFilters = async () => {
    let filters:ISlicerState[] = [];

    if (report) {
      const currentPage:Page = await report.getActivePage()
      const slicers:any = await currentPage.getSlicers();

      const result:any = await Promise.all(slicers.map(async (slicer:any) => {
        const slicerState:any = await slicer.getSlicerState();
        
        let filter = {};

        if (slicerState.filters.length > 0 && slicerState.filters[0]?.target) {
          filter = {
            name: slicerState.filters[0].target.column,
            values: slicerState.filters[0].values,
          };
        }

        return filter;
      }));

      return {
        filter: result.filter((item:any) => Object.keys(item).length !== 0),
        reportTabName: currentPage.displayName,
      }
    }
  }
  const menu = (
    <Menu>
      <Menu.Item key="1">
        <ExportButton resourceid={reportState.report?.resourceId} getFilters={getFilters} /> 
      </Menu.Item>
    </Menu>
  );

  const pageChangedHandler = (event: any) => {
    console.log("pageChanged")
    const hasExport: boolean = reportState.report.config.hasExport ?? false;

    if (hasExport && event.detail?.newPage?.displayName) {
      console.log(event.detail.newPage.displayName);

      const tabName:string = event.detail.newPage.displayName;
      const exportTabName:string = reportState.report.config.exportTabName;

      if (tabName.toLowerCase().includes(exportTabName.toLowerCase())) {
        setShowMenu(true);
      } else {
        setShowMenu(false);
      }
    }
  }

    if (reportState.error.status)
      return(<ExceptionPage status={reportState.error.status} ticket={reportState.error?.data?.ticket}/>);

    return (
      <Fragment>
        {!isEmptyObject(reportState.report) && report !== undefined && isMobile && reportState.report.config.showMobileTab
          ? <NavigationList report={report} /> : <div></div>
        }

        {showMenu &&
        (<Affix style={{ position: 'fixed', bottom: 60, right: 20 }}>
          <Dropdown overlay={menu} placement="topRight">
            <ExportButton resourceid={reportState.report?.resourceId} getFilters={getFilters} /> 
          </Dropdown>
        </Affix>
        )}

        {!isEmptyObject(reportState.report) ? 
          <PowerBIEmbed
            embedConfig = {powerbiInfo}
            eventHandlers = { 
              new Map([
                ['loaded', function (event, repo) {
                  console.log('Report loading');
                  setReport(repo as Report);
                  console.warn(powerbiTypes.REPORT_STATUS_LOADING);
                }],
                ['rendered', function () {console.log('Report rendered'); console.warn(powerbiTypes.REPORT_STATUS_RENDERED);}],
                ['error', function (event) {
                  if(event?.detail.message){
                    console.warn(event.detail.detailedMessage);
                  }
                }],
                ['pageChanged', pageChangedHandler]
              ])
            }
              
            cssClassName = { `report-style-class ${(reportState.report.config?.showHeader && !menuState?.menu.fullScreen) ? 
            'report-custom-header':'report-custom-header-fullScreen'}` }
            getEmbeddedComponent = { (embedObject: Embed) => {
              setReport(embedObject as Report);
              //const report:Report = powerbi.get(document.getElementById('holamundo'));
              //setReport(report);
            }}
            />:<div></div>
            
        }
      </Fragment>
    );
}

export default PowerBIEmbedComponent;